import React from "react"
import styled from "styled-components"
import Layout from "../Layout";
import projects from "../../consts/projects";
import Reference from "../Welcome/Reference";
import {BigCenter, Center, PageTitle} from "../shared/mix";
import CTA from "../CTA";
import SEO from "../SEO";

const Portfolio = () => {
    return (
        <Layout>
            <SEO
                title="Reference — Portfolio projektů"
                description="Portfolio web developera Matěje Půhoného. Webové stránky, mobilní aplikace a systémy na míru. Mailpay, Pixeland, Steller, Laser Game HK, BurzaŠkol a další projekty."
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "CollectionPage",
                    "name": "Reference — Matěj Půhoný",
                    "description": "Portfolio webových projektů",
                    "mainEntity": {
                        "@type": "ItemList",
                        "itemListElement": projects.map((p, i) => ({
                            "@type": "ListItem",
                            "position": i + 1,
                            "name": p.name,
                            "description": p.sub
                        }))
                    }
                }}
            />
            <Center>
                <PageTitle>Reference</PageTitle>
                <Subtitle>
                    Výběr z projektů, na kterých jsem pracoval.
                    Od webových stránek přes mobilní aplikace až po komplexní systémy.
                </Subtitle>
            </Center>
            <BigCenter>
                <ProjectList>
                    {projects.map((project, index) => (
                        <Reference project={project} index={index} key={index}/>
                    ))}
                </ProjectList>
            </BigCenter>
            <CTA/>
        </Layout>
    )
}

export default Portfolio

const Subtitle = styled.p`
  text-align: center;
  max-width: 34em;
  margin: -1.5em auto 4.5em;
  font-size: 1.15em;
  line-height: 1.7;
  opacity: 0.55;
  font-weight: 300;
`

const ProjectCount = styled.div`
  text-align: center;
  font-size: 0.8em;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.3;
  margin-bottom: 5em;
`

const ProjectList = styled.div`
  display: flex;
  flex-direction: column;
`
